import { api } from "@/lib/api";

// Realtime conversation-state events (pin, unread, favourite, alert, dialog state) pushed by the backend per account + RBAC.
export const CONV_EVENTS = ["conversation.updated", "DIALOG_PINNED", "DIALOG_UNPINNED", "DIALOG_UPDATED", "UNREAD_UPDATED", "DIALOG_PRIORITY_UPDATED",
  "FAVORITE_UPDATED", "SUPERVISOR_ALERT_CREATED", "SUPERVISOR_ALERT_RESOLVED", "MESSAGES_READ"];

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// Chunked, resumable upload: no artificial size limit; each chunk is retried with backoff.
export async function chunkedUpload(file, meta, onProgress) {
  const { data: s } = await api.post("/uploads/chunked", { filename: file.name, mime: file.type || "", size: file.size, ...meta });
  const done = new Set(s.received);
  let sent = 0;
  for (let n = 0; n < s.parts_total; n++) {
    const blob = file.slice(n * s.chunk_size, (n + 1) * s.chunk_size);
    if (!done.has(n)) {
      for (let attempt = 0; ; attempt++) {
        try { await api.put(`/uploads/chunked/${s.upload_id}/${n}`, blob, { headers: { "Content-Type": "application/octet-stream" } }); break; } catch (e) {
          const st = e.response?.status;
          if (attempt >= 5 || (st && st < 500 && st !== 429)) throw e;
          await sleep(1000 * 2 ** attempt);
        }
      }
    }
    sent += blob.size;
    onProgress?.(Math.min(99, Math.round((sent / file.size) * 100)));
  }
  const { data } = await api.post(`/uploads/chunked/${s.upload_id}/complete`);
  onProgress?.(100);
  return data;
}
